/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Row_Per_MonthInputs */

const en_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /mo`)
};

const zh_hans1_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /月`)
};

const pt_br2_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /mês`)
};

const es_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /mes`)
};

const fr_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /mois`)
};

const de_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /Monat`)
};

const ru_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /мес.`)
};

const it_platform_row_per_month = /** @type {(inputs: Platform_Row_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` /mese`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Platform_Row_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_row_per_month = /** @type {((inputs?: Platform_Row_Per_MonthInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Row_Per_MonthInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_row_per_month(inputs)
	if (locale === "pt-BR") return pt_br2_platform_row_per_month(inputs)
	if (locale === "es") return es_platform_row_per_month(inputs)
	if (locale === "fr") return fr_platform_row_per_month(inputs)
	if (locale === "de") return de_platform_row_per_month(inputs)
	if (locale === "ru") return ru_platform_row_per_month(inputs)
	if (locale === "it") return it_platform_row_per_month(inputs)
	return en_platform_row_per_month(inputs)
});